import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useRouteMatch } from 'quartz-routing/react-router';
import { Paths } from '../constants/paths';
import { ALL_REFERRERS } from '../constants/referrers';
import { useProductTypeSearchParams } from '../hooks/useProductTypeSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteReferrerContext = /*#__PURE__*/createContext(undefined);
export function RouteReferrerProvider({
  children,
  referrer: referrerValue
}) {
  const productTypes = useProductTypeSearchParams();
  const {
    path: currentPath
  } = useRouteMatch();
  const [referrer, setReferrer] = useState(() => {
    const matchedReferrer = ALL_REFERRERS.find(_referrer => {
      return referrerValue !== undefined && _referrer.referrers.includes(referrerValue);
    });

    // Ignore internal referrers that point to the current path to prevent
    // self-referential back links (e.g., landing on /breeze-agents with referrer=breeze)
    if ((matchedReferrer === null || matchedReferrer === void 0 ? void 0 : matchedReferrer.referrerType) === 'internal' && matchedReferrer.location.pathname === currentPath) {
      return undefined;
    }
    return matchedReferrer;
  });
  const [referrerPath, setReferrerPath] = useState(() => referrer ? currentPath : undefined);
  const clearReferrer = useCallback(() => {
    setReferrer(undefined);
    setReferrerPath(undefined);
  }, []);
  const referrerRouteMatch = useRouteMatch({
    path: referrerPath,
    exact: true
  });
  useEffect(() => {
    if (!(referrer !== null && referrer !== void 0 && referrer.productType)) return;
    if (referrerRouteMatch) return;
    switch (currentPath) {
      case Paths.LISTING_DETAILS:
        break;
      case Paths.SEARCH_RESULTS:
        {
          if (!productTypes.length || !productTypes.every(t => t === referrer.productType)) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            clearReferrer();
          }
          break;
        }
      default:
        clearReferrer();
        break;
    }
  }, [clearReferrer, currentPath, productTypes, referrer, referrerRouteMatch]);

  // Provide the referrer without gating on referrerRouteMatch so that proxy
  // routes (e.g., /breeze-agents/all) can show the back link after redirecting.
  // The useEffect above handles clearing the referrer on disallowed paths.
  return /*#__PURE__*/_jsx(RouteReferrerContext.Provider, {
    value: referrer,
    children: children
  });
}
export function useRouteReferrer() {
  return useContext(RouteReferrerContext);
}